<div class="container">
  <div class="row py-2 py-lg-4 w-100 m-0">
    <div class="col-12" [innerHTML]="terms"></div>
  </div>
</div>
